import * as React from "react"
import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("bg-zinc-200 animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
